/* eslint-disable import/prefer-default-export */
import { Streams } from '../../../Types';
import { conversationsActions } from '../..';
import { ParticipantLeftConversation, ConversationEventTypes } from '../../../Types/Conversations/Events';
import { ParticipantLeftConversationWrappedEvent } from '../../../Types/Conversations/WrappedEvents';
import { ConversationsActionTypes } from '../../Conversations/actions';

export const participantLeftConversationHandler = (
    { conversationId, metadata, userId }: Streams.ParticipantLeftConversationStreamMessage,
    currentUserId: number,
    dispatch,
): void => {
    const { eventDate: LeftDate } = metadata;
    if (currentUserId === userId) {
        dispatch({
            type: conversationsActions.SET_CONVERSATION_INACTIVE,
            payload: conversationId,
        } as ConversationsActionTypes);
    }

    dispatch({
        type: conversationsActions.ADD_EVENT_TO_CONVERSATION,
        payload: {
            conversationId: conversationId,
            event: {
                type: ConversationEventTypes.ParticipantLeftConversation,
                event: {
                    conversationId: conversationId,
                    metadata: {
                        eventDate: LeftDate,
                        userId: userId,
                    },
                    userId: userId,
                } as ParticipantLeftConversation,
            } as ParticipantLeftConversationWrappedEvent,
        },
    } as ConversationsActionTypes);
};
